import React from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import CloseIcon from '@material-ui/icons/Close';

export const DetailsModalScaffold = ({
  isOpen,
  toggle,
  handleClose,
  children,
  className,
  isReturn,
}) => {
  const [windowWidth, setWindowWidth] = React.useState(window.innerWidth);

  const isSM = windowWidth <= 600;
  React.useEffect(() => {
    window.addEventListener('resize', () => {
      setWindowWidth(window.innerWidth);
    });
    return () => {
      window.addEventListener('resize', () => {
        setWindowWidth(window.innerWidth);
      });
    };
  }, []);
  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      backdrop='static'
      wrapClassName='modal-right'
      className={`${className} details-modal`}
    >
      <ModalHeader className='detail-modal-header'>
        <div
          className='glyph back-btn btn-link'
          style={{ justifyContent: isReturn ? 'space-between' : null }}
          onClick={handleClose}
        >
          {isReturn ? null : (
            <div className={`glyph-icon simple-icon-arrow-left`} />
          )}
          <span
            className='btn-name'
            style={{ color: isReturn ? '#2E2B2B' : '#ACBAE1', fontFamily: 'Brown' }}
          >
            {isReturn ? 'Return' : 'Back'}
          </span>
          {isReturn ? <CloseIcon  style={{ color: '#2E2B2B' }}/> : null}
        </div>
      </ModalHeader>
      <ModalBody className='content'>{children}</ModalBody>
    </Modal>
  );
};
